module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('scroll', {
    directives: [{
      name: "pull",
      rawName: "v-pull",
      value: (_vm.refresh),
      expression: "refresh"
    }]
  }, [_c('no-record', {
    attrs: {
      "condition": _vm.visitInfo,
      "tips": "暂无就诊记录"
    }
  }), _vm._v(" "), _vm._l((_vm.visitInfo.treatItems), function(treatItem, index) {
    return _c('section', {
      staticClass: "thick"
    }, [_c('div', {
      staticClass: "panel"
    }, [_vm._v("就诊序号 \n                "), _c('span', {
      staticClass: "f-strong"
    }, [_vm._v(_vm._s(_vm._f("formatNum")(index + 1)))])]), _vm._v(" "), _c('div', {
      staticClass: "row arr-row table-row"
    }, [_c('div', {
      staticClass: "col"
    }, [_c('span', {
      staticClass: "f-minor"
    }, [_vm._v("就诊日期")]), _vm._v("  "), _c('span', {
      staticClass: "f-minor"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(treatItem.treatDate)))])]), _vm._v(" "), _c('div', {
      staticClass: "col"
    }, [_c('button', {
      staticClass: "btn-minor-blue btn-position",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.goVisitDetail(index)
        }
      }
    }, [_vm._v("查看")])])])])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ef6d630","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/healthRecord/VisitRecord.vue
// module id = 798
// module chunks = 0